import { render, staticRenderFns } from "./DynamicDuration.vue?vue&type=template&id=53a34d32&"
import script from "./DynamicDuration.vue?vue&type=script&lang=js&"
export * from "./DynamicDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a34d32')) {
      api.createRecord('53a34d32', component.options)
    } else {
      api.reload('53a34d32', component.options)
    }
    module.hot.accept("./DynamicDuration.vue?vue&type=template&id=53a34d32&", function () {
      api.rerender('53a34d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/ui/DynamicDuration.vue"
export default component.exports